<template>
  <div>
    <div v-if="loading" class="loader"></div>
    <h3 align="center" v-if="loading">Loading Data...</h3>
    <div v-if="!loading">
      <b-row>
        <b-col lg="12">
          <h3 align="center">ClickHouse City Count Logs</h3>

          <div class="clickhouse-filter-panel">
            <div class="clickhouse-filter-bar">
            <div class="filter-field date-filter-field">
              <label>From</label>
              <input
                type="date"
                v-model="filterStartDate"
              />
            </div>

            <div class="filter-field date-filter-field">
              <label>To</label>
              <input
                type="date"
                v-model="filterEndDate"
              />
            </div>
            <div class="filter-field">
              <label>Username</label>
              <b-form-select v-model="filterUserId">
                <b-form-select-option value="">Select Username</b-form-select-option>
                <b-form-select-option
                  v-for="(user, index) in userList"
                  :key="index"
                  :value="user.user_id"
                >
                  {{ user.decrypted_username }}
                </b-form-select-option>
              </b-form-select>
            </div>
            <div class="filter-field">
              <label>Location</label>
              <input type="text" v-model="filterLocation" placeholder="Locations..." />
            </div>
            <div class="filter-field">
              <label>Country</label>
              <input type="text" v-model="filterCountry" placeholder="Country..." />
            </div>
            <div class="filter-actions">
              <b-button variant="primary" @click="fetchLogs2()">Submit</b-button>
              <b-button variant="outline-primary" @click="handleReset()">Reset</b-button>
            </div>
          </div>
          </div>

          <h2 class="text-center p-5" v-if="nodata">No Data Found</h2>
          <div v-else>
            <div class="pagination mt-3">
              <a href="#" @click.prevent="previousPage" :class="{ disabled: currentPage === 1 }">&laquo;</a>
              <a
                v-for="page in visiblePages"
                :key="page"
                :class="{ active: currentPage === page }"
                @click.prevent="goToPage(page)"
              >
                {{ page }}
              </a>
              <a href="#" @click.prevent="nextPage" :class="{ disabled: currentPage === totalPages }">&raquo;</a>
            </div>

            <b-spinner variant="primary" class="dosyun" v-if="isLoading"></b-spinner>
            <table v-else>
              <thead>
                <tr>
                  <th v-for="col in displayColumns" :key="col">
                    {{ formatColumnName(col) }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(rw, index) in activelogs.data" :key="index">
                  <td>{{ rw.Date }}</td>
                  <td>
                    {{ locationLabel(rw) }}
                    <b-icon
                      @click="saveverifiedcity(rw.location, rw.country, rw.state)"
                      class="verify"
                      v-if="rw.verification != '1' && rw.verification != 1 && addaccess != 0"
                      style="color: red;"
                      icon="x-circle-fill"
                    ></b-icon>
                  </td>
                  <td>{{ rw.country }}</td>
                  <td>{{ rw.Daily_City_Count }}</td>
                  <td>
                    {{ rw.Overall_City_Count }}
                    <b-icon
                      @click="updateredislist(rw.location, rw.country, rw.state)"
                      class="verify"
                      v-if="rw.redisadd != '1' && rw.redisadd != 1 && addaccess != 0"
                      style="color: green;"
                      icon="x-circle-fill"
                    ></b-icon>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="pagination">
              <a href="#" @click.prevent="previousPage" :class="{ disabled: currentPage === 1 }">&laquo;</a>
              <a
                v-for="page in visiblePages"
                :key="page"
                :class="{ active: currentPage === page }"
                @click.prevent="goToPage(page)"
              >
                {{ page }}
              </a>
              <a href="#" @click.prevent="nextPage" :class="{ disabled: currentPage === totalPages }">&raquo;</a>
            </div>

            <div class="pagination-container">
              <input
                type="number"
                v-model.number="goToPageInput"
                class="mx-2 hhsna"
                :min="1"
                :max="totalPages"
                placeholder="Page #"
              />
              <p class="parabase">out of {{ totalPages }}</p>
              <b-button
                variant="success"
                class="hsggaf"
                @click="goToSpecificPage"
                :disabled="!isValidPage(goToPageInput)"
              >
                Go
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BSpinner, BButton, BIcon, BFormSelect, BFormSelectOption,
} from "bootstrap-vue"

export default {
  components: {
    BRow,
    BCol,
    BSpinner,
    BButton,
    BIcon,
    BFormSelect,
    BFormSelectOption,
  },
  data() {
    return {
      loading: true,
      isLoading: false,
      nodata: false,
      activelogs: {
        columns: ["Date", "location", "country", "state", "Daily_City_Count", "Overall_City_Count", "action"],
        data: [],
        pagination: {
          total_pages: 1,
          current_page: 1,
          limit: 200,
        },
      },
      displayColumns: ["Date", "location", "country", "Daily_City_Count", "Overall_City_Count"],
      filterStartDate: this.$route.query.date || '',
      filterEndDate: this.$route.query.date || '',
      filterUserId: '',
      filterLocation: '',
      filterCountry: '',
      userList: [],
      currentPage: 1,
      totalPages: 1,
      goToPageInput: null,
    }
  },
  computed: {
    visiblePages() {
      const pages = []
      const startPage = Math.max(1, this.currentPage - 2)
      const endPage = Math.min(this.totalPages, this.currentPage + 2)
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i)
      }
      return pages
    },
  },
  mounted() {
    this.fetchUsers()
    this.fetchLogs()
  },
  methods: {
    fetchUsers() {
      axios.get('usernames/').then(response => {
        this.userList = response.data
      }).catch(error => {
        console.log("Something went wrong in fetchUsers()", error)
      })
    },
    fetchLogs() {
      this.isLoading = true
      this.nodata = false
      axios.post('clickhouse_city_count_logs', {
        page: this.currentPage,
        start_date: this.filterStartDate,
        end_date: this.filterEndDate,
        user_id: this.filterUserId,
        location: this.filterLocation,
        country: this.filterCountry,
      }).then(response => {
        if (!response.data || !response.data.logs) {
          this.nodata = true
          return
        }
        this.activelogs = response.data.logs
        this.totalPages = response.data.logs.pagination ? response.data.logs.pagination.total_pages || 1 : 1
        this.nodata = response.data.error === 'No data found.' || response.data.logs.data.length === 0
      }).catch(error => {
        console.error("Error fetching ClickHouse city count logs:", error)
        this.nodata = true
      }).finally(() => {
        this.isLoading = false
        this.loading = false
      })
    },
    fetchLogs2() {
      this.currentPage = 1
      this.fetchLogs()
    },
    handleReset() {
      this.filterStartDate = ''
      this.filterEndDate = ''
      this.filterUserId = ''
      this.filterLocation = ''
      this.filterCountry = ''
      this.currentPage = 1
      this.fetchLogs()
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchLogs()
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
        this.fetchLogs()
      }
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
        this.fetchLogs()
      }
    },
    goToSpecificPage() {
      if (this.isValidPage(this.goToPageInput)) {
        this.currentPage = this.goToPageInput
        this.goToPageInput = null
        this.fetchLogs()
      }
    },
    isValidPage(page) {
      return page >= 1 && page <= this.totalPages
    },
    formatColumnName(column) {
      const columnLabels = {
        Date: 'DATE',
        location: 'LOCATION',
        country: 'COUNTRY',
        Daily_City_Count: 'TODAY COUNT',
        Overall_City_Count: 'OVERALL COUNT',
      }
      return columnLabels[column] || column.replace(/_/g, ' ').toUpperCase()
    },
    locationLabel(row) {
      const state = this.normalizeState(row.state)
      if (state && state !== 'na' && state !== 'None' && state !== 'null') {
        return `${row.location} (${state})`
      }
      return row.location
    },
    updateredislist(location, country, state) {
      for (let index = 0; index < this.activelogs.data.length; index++) {
        if (
          this.activelogs.data[index].location === location &&
          this.activelogs.data[index].country === country &&
          this.activelogs.data[index].state === state
        ) {
          this.activelogs.data[index].redisadd = 1
        }
      }
      axios.post('redisaddcity', {
        location: location,
        country: country,
        state: state,
      }).catch(error => {
        console.log("Something went wrong in updateredislist()", error)
      })
    },
    saveverifiedcity(location, country, state) {
      for (let index = 0; index < this.activelogs.data.length; index++) {
        if (
          this.activelogs.data[index].location === location &&
          this.activelogs.data[index].country === country &&
          this.activelogs.data[index].state === state
        ) {
          this.activelogs.data[index].verification = 1
        }
      }
      axios.post('saveverifiedcities', {
        location: location,
        country: country,
        state: state,
      }).catch(error => {
        console.log("Something went wrong in saveverifiedcity()", error)
      })
    },
    normalizeState(state) {
      return state || 'na'
    },
  },
}
</script>

<script setup>
const addaccess = localStorage.getItem('add_access')
</script>

<style scoped>
.clickhouse-filter-panel {
  background: linear-gradient(180deg, #f8fbff 0%, #f2f7fd 100%);
  border: 1px solid #d7e3f0;
  border-radius: 14px;
  margin: 18px 0 20px;
  padding: 18px;
}

.clickhouse-filter-bar {
  display: grid;
  grid-template-columns: repeat(5, minmax(150px, 1fr)) auto;
  gap: 14px;
  align-items: end;
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.date-filter-field {
  min-width: 0;
}

.filter-field label {
  color: #172033;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 7px;
  letter-spacing: 0.02em;
}

.filter-field input,
.filter-field select,
.filter-field :deep(.custom-select) {
  background-color: #fff;
  border: 1px solid #c9d3df;
  border-radius: 10px;
  color: #172033;
  font-size: 14px;
  height: 44px;
  outline: none;
  padding: 10px 12px;
  width: 100%;
}

.filter-field input:focus,
.filter-field select:focus,
.filter-field :deep(.custom-select:focus) {
  border-color: #2d8cf0;
  box-shadow: 0 0 0 2px rgba(45, 140, 240, 0.12);
}

.filter-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  min-height: 44px;
  padding-top: 20px;
}

.filter-actions :deep(.btn) {
  border-radius: 10px;
  height: 44px;
  min-width: 92px;
  font-weight: 600;
  padding: 0 18px;
}

@media (max-width: 1200px) {
  .clickhouse-filter-bar {
    grid-template-columns: repeat(3, minmax(180px, 1fr));
  }
}

@media (max-width: 768px) {
  .clickhouse-filter-panel {
    padding: 14px;
  }

  .clickhouse-filter-bar {
    grid-template-columns: 1fr;
  }

  .filter-actions {
    padding-top: 0;
  }
}
</style>
